import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

type Props = {
  isSelected?: boolean;
  onClick: () => void;
  children: ReactNode;
  isSecondary?: boolean;
};

export const Cell = ({ isSelected, isSecondary, onClick, children }: Props) => {
  return (
    <span
      className={twJoin(
        'block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center font-semibold text-sm',
        isSelected ? 'bg-blue-700 text-white dark:bg-blue-600' : 'hover:bg-gray-100 dark:hover:bg-gray-600',
        isSecondary ? 'dark:text-gray-300 text-gray-500' : 'dark:text-white text-gray-900',
      )}
      onClick={onClick}
    >
      {children}
    </span>
  );
};
